// ENG-2504: Action Logs show times in the site's timezone, labelled with the
// zone ("Oct 20, 2026, 6:44 AM EDT"), so CS staff abroad don't have to convert.
// Falls back to the viewer's browser timezone when the site has none, or an
// unrecognised one (Intl throws a RangeError on unknown zone names).

const BASE_OPTIONS: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  hour12: true,
  timeZoneName: "short",
};

export const formatSiteTimestamp = (
  date: Date,
  siteTimezone?: string | null
): string => {
  if (siteTimezone) {
    try {
      return date.toLocaleString("en-US", {
        ...BASE_OPTIONS,
        timeZone: siteTimezone,
      });
    } catch {
      // Unknown zone name: fall through to browser time.
    }
  }
  return date.toLocaleString("en-US", BASE_OPTIONS);
};
